export const ABOUT = "/about-us"
export const CAREERS = "/careers"
export const CONTACT_US = "/contact-us"
export const CONTACT_US_FOR_AGENTS = "/contact-us-for-agents"
export const FAQ = "/faq"
export const AGENT_PROGRAM = "/agent-program"
export const PERSONAL_ACCOUNT = "/account-info-personal"
export const BUSINESS_ACCOUNT = "/account-info-business"
export const PRICING = "/pricing"
export const PRICING_PERSONAL_ACCOUNT = "/pricing/pricing-personal"
export const PRICING_BUSINESS_ACCOUNT = "/pricing/pricing-business"
export const TERMS_AND_CONDITIONS = "/terms-and-conditions"
export const TERMS_AND_CONDITIONS_PERSONAL = "/terms-and-conditions/personal"
export const TERMS_AND_CONDITIONS_BUSINESS = "/terms-and-conditions/business"
export const PRIVACY_POLICY = "/privacy-policy"
export const COOKIE_POLICY = "/cookie-policy"
export const COMPLAINTS = "/complaints"
export const KYC_SUCCESS = "/kyc-success"
export const KYC_SUCCESS_BUSINESS = "/kyc-success-business"
export const KYC_DECLINED = "/kyc-declined"
export const KYC_FAILURE = "/kyc-failure"
export const FRAUD_AND_SCAM_ALERT = "/fraud-and-scam-alert"
export const KYB_FAILURE = '/kyb-failure'
export const KYB_SUCCESS = "/kyb-success"
export const KYB_DECLINED = "/kyb-declined"
